import { render, staticRenderFns } from "./costIncomeReport.vue?vue&type=template&id=42870919&scoped=true&"
import script from "./costIncomeReport.vue?vue&type=script&lang=js&"
export * from "./costIncomeReport.vue?vue&type=script&lang=js&"
import style0 from "./costIncomeReport.vue?vue&type=style&index=0&id=42870919&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42870919",
  null
  
)

export default component.exports